export function getTimeRemaining(futureDate: Date | string) {
  const future = futureDate instanceof Date ? futureDate : new Date(futureDate);
  future.setHours(24,0,0,0);

  if (isNaN(future.getTime())) {
    console.error("Invalid date provided:", futureDate);
    return { days: "00", hours: "00", minutes: "00", seconds: "00" };
  }
  
  const now = new Date();
  const diffInSeconds = Math.floor((future.getTime() - now.getTime()) / 1000);

  if (diffInSeconds <= 0) {
    return { days: "00", hours: "00", minutes: "00", seconds: "00" };
  }

  const days = Math.floor(diffInSeconds / 86400)
    .toString()
    .padStart(2, "0");
  const hours = Math.floor((diffInSeconds % 86400) / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((diffInSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (diffInSeconds % 60).toString().padStart(2, "0");

  return { days, hours, minutes, seconds };
}
